// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"445":"179d9b69","453":"d9ded2d7","800":"4ac6b920"}[chunkId] + ".chunk.js";
};